// Banner em vídeo da página de venda alternativa. A imagem do banner continua
// na página como poster e fallback; o vídeo carrega por cima e só aparece
// quando começa a tocar. A caixa do banner segue a proporção do vídeo, para
// ele nunca ser cortado. Fica só a imagem quando o visitante pede menos
// movimento, está em economia de dados, o navegador não toca MP4 ou o vídeo
// falha.

// Vídeo que vale para a largura atual ('' quando aquele tamanho não tem vídeo).
export function videoSource(video, isDesktop) {
  return (isDesktop ? video.dataset.desktop : video.dataset.mobile) || '';
}

// Proporção real do vídeo, no formato do CSS aspect-ratio ('' enquanto o
// navegador ainda não leu as dimensões).
export function videoAspectRatio(video) {
  return video.videoWidth > 0 && video.videoHeight > 0 ? `${video.videoWidth} / ${video.videoHeight}` : '';
}

export function canPlayBannerVideo(video, env = {}) {
  const {
    reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches,
    saveData = Boolean(navigator.connection && navigator.connection.saveData),
  } = env;
  if (reducedMotion || saveData) return false;
  return Boolean(video.canPlayType && video.canPlayType('video/mp4'));
}

export default function startBannerVideo(banner) {
  const video = banner && banner.querySelector('.bvid');
  if (!video || !canPlayBannerVideo(video)) return;

  // A caixa do banner nasce com a proporção da imagem de fallback. Assim que o
  // vídeo informa as dimensões dele, a caixa passa a seguir o VÍDEO e a imagem
  // é que se ajusta — fallback em outra proporção não corta mais o vídeo.
  const fitToVideo = () => {
    const ratio = videoAspectRatio(video);
    banner.style.aspectRatio = ratio;
    banner.classList.toggle('sized', Boolean(ratio));
  };
  const fitToImage = () => {
    banner.style.aspectRatio = '';
    banner.classList.remove('sized');
  };

  const desktop = matchMedia('(min-width:768px)');
  const load = () => {
    const source = videoSource(video, desktop.matches);
    if (video.dataset.src === source) return;
    video.dataset.src = source;
    banner.classList.remove('playing');
    fitToImage();
    if (!source) {
      video.removeAttribute('src');
      video.load();
      return;
    }
    video.src = source;
    video.load();
    video.play().catch(() => {});
  };

  video.addEventListener('playing', () => banner.classList.add('playing'));
  video.addEventListener('loadedmetadata', fitToVideo);
  video.addEventListener('error', () => { banner.classList.remove('playing'); fitToImage(); });
  // repete sem parar: alguns navegadores pausam o vídeo (aba oculta, economia de energia) ou ignoram o loop
  video.loop = true;
  let attempts = 0;
  const resume = () => { if (video.dataset.src && video.paused && attempts++ < 500) video.play().catch(() => {}); };
  video.addEventListener('pause', () => setTimeout(resume, 250));
  video.addEventListener('ended', () => { video.currentTime = 0; resume(); });
  document.addEventListener('visibilitychange', () => { attempts = 0; resume(); });

  load();
  if (desktop.addEventListener) desktop.addEventListener('change', load);
}
